import type { FaireProductEntity } from "../../entity_types/product";

export const p_snqggxjskf: FaireProductEntity = {
  token: "p_snqggxjskf",
  type: "product",
  name: "Cool Moms Love Jesus Christian Graphic Sweatshirt",
  brandToken: "b_5vj7ku5zz3",
  brandName: "Shoppe SHC",
  imageUrl:
    "https://cdn.faire.com/fastly/eae48b7ce0fae06e5679fcbb2e5240d4ff39fdb82ed4dfca307d8105d098a6a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fcdeb4930bf22fc31f85bc882ee8c9b18c769cc470a6bbb43b225682fc20f793.jpeg",
    "https://cdn.faire.com/fastly/2e754e347480ab1e02915e65ef67f6112edf17516e6078043f51f14d5efcfcf3.jpeg",
    "https://cdn.faire.com/fastly/2ff71c93a4e2ca23a5f24afd129a9d4db0e4fcfdde46701c945e713ed39f1642.jpeg",
    "https://cdn.faire.com/fastly/9924be9b06923ce5a5367f2e39f7272dc81096bf18242be7569bab1476d0310c.jpeg",
    "https://cdn.faire.com/fastly/02b0f34fcf1b59f45dcf1c0d95373196a438c38f196e4f7f13e5b123dac5330d.jpeg",
    "https://cdn.faire.com/fastly/90e0b69d5dbced0be06812292d800a8054549c3148245f4876aaf5747fd2dde5.jpeg",
    "https://cdn.faire.com/fastly/f414d4439a4c4d0e4e1a37a6c00a45ebbb81d1498946ecb23c4dd6964af9d800.jpeg",
    "https://cdn.faire.com/fastly/29e9282e6db70553cbfc0ccd8e3b23b7cdb735304408a3694c2856dc43813fa7.jpeg",
    "https://cdn.faire.com/fastly/2d4e7d7877e74abec435256398b83d98949fa1d6342bd735cc043c6857f980de.jpeg",
    "https://cdn.faire.com/fastly/2b608663794451f474b6436757de9e7bf4565f57cf46a243f9479eeb6305269f.jpeg",
    "https://cdn.faire.com/fastly/530b99cd3db02285700c78b345a5ee9c00107427449acd75b66f46a131e0a43f.jpeg",
    "https://cdn.faire.com/fastly/60809863b21a17dee3c1cc070f7e948e75e70b85490a557a9d867dcb550be5b4.jpeg",
    "https://cdn.faire.com/fastly/170801afa865f3778f4b83b2e64ceb9ace24561bfe08a6014696f7f683dc02b2.jpeg",
    "https://cdn.faire.com/fastly/f3d5bed4eda182057c8201c073202849a131d5d855b21c03353202e5a84b302c.jpeg",
    "https://cdn.faire.com/fastly/95a00afaa02180f807500a63f8004d474e2c630c3c410417a36f6dc04da98940.jpeg",
    "https://cdn.faire.com/fastly/e24fdbc244c39109ef73ba0edb44aa1249cdd2acf7f818f4b7e26d998febde90.jpeg",
    "https://cdn.faire.com/fastly/d77e75f634423013b713a04a5b85dea62407e7f77ce976f61f06c53bdda24455.jpeg",
  ],
  priceDollars: 24.65,
  description:
    "\n\nProduct Description: \nDirect to garment screen printed \nBrand Gildan \n\n Our graphic tees are very soft and trendy. They are long enough to wear with a pair of leggings, soft enough to roll the sleeves and if you want to add some flair, just tie it up in a knot. However you decide to wear it, you'll love the fit and comfort of this tee.\n\nSHIRT DETAILS\n\nThe shirts are UNISEX - they are meant to have a loose fit so if you would like it to be more tight, it is recommended to order a size down.\n\n\n\n- 100% combed and ring-spun cotton \n- Fabric weight: 4.2 oz (142 g/m2)\n- Shoulder-to-shoulder taping\n- Side-seamed\n- Tear away tag",
  tags: [],
  msrpDollars: 49.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:49.970Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
